import { trackEvent } from './countly';

export const trackNotificationItemClicked = (): void => trackEvent({ key: 'Clicked a notification' });
